'use client';

import { BaseResponse, logServer } from './api_request';
import { handleRequest } from './handle_request';

export async function updateUserInfo(documentId: string, update: (session: any) => Promise<void>): Promise<BaseResponse> {
  const response = await handleRequest(
    `/users`,
    'PATCH',
    {
      document_id: documentId,
    },
    update
  );

  try{
    await update({
      user: {
        customer_id: response.data?.customer_id,
        user_status: response.data?.status,
      }
    })
  } catch (error) {
    console.error("Error updating user info:", error);
  }
  logServer("res status in update user info:::", response.data)

  return response;
}

export async function confirmOtp(otpValue: string, update: (session: any) => Promise<void>) {
  const response = await handleRequest(
    `/users/confirm`,
    "POST",
    { otp_value: otpValue },
    update,
  )
  
  try{
    await update({
      user: {
        customer_id: response.data?.customer_id,
        user_status: response.data?.status,
      }
    })
  } catch (error) {
    console.error("Error updating user info:", error);
  }
  logServer("res comfirm in update user info:::", response.data)
  
  return response
}

export async function getUserInfo(update: (session: any) => void) {
  const response = await handleRequest(
    `/users/info`,
    "GET",
    null,
    update
  )
  return response
}

export async function acceptTermAndCond(update: (session: any) => void) {
  return await handleRequest(
    `/users/accept-term-and-cond`,
    "POST",
    null,
    update
  )
}

export async function sendOTP(update: (session: any) => void , isDisconnectUser: boolean = false) {
  const url = '/users/otp/send' + (isDisconnectUser ? '?action=disconnect' : '');
  return await handleRequest(
    url,
    "POST",
    null,
    update
  )
}

export async function resendOTP(update: (session: any) => void, isDisconnectUser : boolean = false) {
  const url = '/users/otp/resend' + (isDisconnectUser ? '?action=disconnect' : '');
  return await handleRequest(
    url,
    "POST",
    null,
    update
  )
}

export async function disconnectUser(otp : string , update: (session: any) => void) {
  const response = await handleRequest(
    `/users/disconnect`,
    "POST",
    { otp_value: otp },
    update
  )

  try{
    await update({
      user: {
        customer_id: response.data?.customer_id,
        user_status: response.data?.status,
      }
    })
  } catch (error) {
    console.error("Error updating user info:", error);
  }
  
  logServer("res disconnect in update user info:::", response.data)
  
  return response
}

export async function getUserStatus(update: (session: any) => Promise<any>) {
  return  await handleRequest(
    `/users/status`,
    "GET",
    null,
    update
  )
}